// extracted by mini-css-extract-plugin
export const btn = "button-module--btn--1_djD";